export enum SpacingStyling {
  ALL_TABLES = 'allTables',
  HOME_PAGE_LAYOUT = 'homePageLayout',
  PAGE_CONTAINER = 'pageContainer',
  MY_DATA = 'myData',
  PEO_TABLE_STAFF = 'peoTable',
}

export const spacingStyling: Record<SpacingStyling, string> = {
  [SpacingStyling.ALL_TABLES]: '16px',
  [SpacingStyling.HOME_PAGE_LAYOUT]: '16px 32px 32px 32px',
  [SpacingStyling.PAGE_CONTAINER]: '32px 40px 0',
  [SpacingStyling.MY_DATA]: '32px',
  [SpacingStyling.PEO_TABLE_STAFF]: '16px',
};
